import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import bgImage from '../../assets/home/bg-5.png';
import screen1 from '../../assets/home/screen-1.png';

const BENEFITS = [
  'Aggregated listings from eBay, TCGplayer, and Canadian shops',
  'Real-time price data and historical charts',
  'Collection tracking with live portfolio values',
  'Multi-currency price display',
];

export default function CTASection() {
  return (
    <section
      style={{ backgroundImage: `url(${bgImage})` }}
      className="relative flex min-h-[90vh] items-center overflow-hidden bg-cover bg-center bg-no-repeat bg-fixed py-24 md:py-32"
    >
      <div className="absolute inset-0 z-0 bg-black/90 backdrop-blur-[8px]" />

      <div className="relative z-20 mx-auto w-full max-w-7xl px-6">
        <div className="mb-10 flex flex-col items-center text-center lg:mb-24">
          <h2 className="mb-6 max-w-4xl font-landing-display text-4xl font-bold md:text-5xl lg:text-6xl">
            Start Finding <br />
            <span className="landing-text-gradient">Better Deals Today.</span>
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-text-secondary">
            Lilycove is free to use. No credit card. No signup required to begin searching.
          </p>
        </div>

        <div className="mb-10 block lg:hidden">
          <div className="mx-auto max-w-md overflow-hidden rounded-2xl border border-border-base bg-bg-surface shadow-2xl">
            <div className="flex h-8 items-center gap-2 border-b border-border-base bg-bg-elevated px-4">
              <div className="h-3 w-3 rounded-full bg-border-hi" />
              <div className="h-3 w-3 rounded-full bg-border-hi" />
              <div className="h-3 w-3 rounded-full bg-border-hi" />
            </div>
            <img src={screen1} alt="Lilycove app preview" className="h-auto w-full object-cover object-top" loading="lazy" />
          </div>
        </div>

        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-3 lg:gap-16">
          <div className="lg:col-span-1">
            <ul className="space-y-6">
              {BENEFITS.map((item) => (
                <li key={item} className="group flex items-start gap-5">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-brand-primary/20 bg-brand-primary/10 transition-all group-hover:scale-110 group-hover:bg-brand-primary/20">
                    <CheckCircle2 className="text-brand-hi" size={24} />
                  </div>
                  <span className="mt-2 text-lg text-text-primary transition-colors group-hover:text-brand-hi">{item}</span>
                </li>
              ))}
            </ul>

            <div className="space-y-4 pt-6">
              <Link
                to="/series"
                className="flex w-full items-center justify-center gap-3 rounded-xl bg-brand-primary px-8 py-5 text-xl font-semibold text-white shadow-[0_0_20px_rgba(108,92,231,0.4)] transition-all hover:bg-brand-hi hover:shadow-[0_0_30px_rgba(108,92,231,0.6)] sm:w-auto"
              >
                Start Searching (Free)
                <ArrowRight size={24} />
              </Link>
              <p className="pl-2 text-sm text-text-dim">Join collectors already using Lilycove.</p>
            </div>
          </div>

          <div className="relative z-10 hidden lg:col-span-2 lg:block lg:-mr-12 xl:-mr-24">
            <div className="overflow-hidden rounded-2xl border border-border-base bg-bg-surface shadow-2xl">
              <div className="flex h-8 items-center gap-2 border-b border-border-base bg-bg-elevated px-4">
                <div className="h-3 w-3 rounded-full bg-border-hi" />
                <div className="h-3 w-3 rounded-full bg-border-hi" />
                <div className="h-3 w-3 rounded-full bg-border-hi" />
              </div>
              <img src={screen1} alt="Lilycove app preview" className="h-auto w-full object-cover object-top" loading="lazy" />
            </div>
            <div className="absolute left-1/2 top-1/2 -z-10 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-primary/20 blur-[120px]" />
          </div>
        </div>
      </div>
    </section>
  );
}
